import type { SerializedStyles } from '@emotion/react';
import type { ReactNode } from 'react';

export const NavItemButton = ({
  ariaLabel,
  href,
  label,
  onClick,
  onBlur,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onMouseUp,
  title,
  itemCss,
  children,
}: {
  ariaLabel?: string;
  href?: string;
  label: string;
  onClick: () => void;
  onBlur: () => void;
  onMouseDown: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onMouseUp: () => void;
  title?: string;
  // Named itemCss (not css) — a `css` prop on a custom component is
  // intercepted by Emotion's JSX transform before the component ever
  // receives it (it gets converted into a computed `className` instead), so
  // this has to travel under a different name and get applied to the actual
  // DOM elements below with its own `css` prop.
  itemCss: SerializedStyles[];
  children: ReactNode;
}) =>
  href
    ? (
      <a
        href={href}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onBlur={onBlur}
        aria-label={ariaLabel ?? label}
        title={title ?? label}
        css={itemCss}
      >
        {children}
      </a>
    )
    : (
      <button
        type='button'
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onBlur={onBlur}
        aria-label={ariaLabel ?? label}
        title={title ?? label}
        css={itemCss}
      >
        {children}
      </button>
    );
